import BWDataService from './bw-data.service';
import { PlanType } from 'src/types/user.model';
import { EligibilityModel } from 'src/types/eligibility.model';

export default class EligibilityService extends BWDataService {
    public static async getEligibility(planType: PlanType): Promise<EligibilityModel> {
        const url: string = `/eligible/${planType}`;
        return await this.get(url);
    }
}
